import React, { useEffect, useState, useRef } from 'react'
import { Box, Grid } from '@mui/material';
import Toolbar from '@mui/material/Toolbar';
import MenuIcon from '@mui/icons-material/Menu';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { TabView, TabPanel } from 'primereact/tabview';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import getRequest, { patchRequest } from '../../../assets/helper/ApiHandler';
import { useNavigate } from 'react-router-dom';
import { deleteRequest, putRequest } from '../../../assets/helper/ApiHandler';
import { useDispatch } from 'react-redux';
import { setNotificationsState } from '../../../redux/sampleRedux';

export default function Notifications() {
    const toast = useRef(null);
    const [visibleDeleteNotification, setDeleteNotificationVisible] = useState(false);
    const [deleteNotificationID, setDeleteNotificationID] = useState(null)
    const [notifications, setNotifications] = useState(null);
    const [tabs, setTabs] = useState([]);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        fetchNotifications();    
    },[notifications,]);

    const fetchNotifications = async () => {
        try {
            const res = await getRequest(`/notifications`, null, navigate);
            dispatch(setNotificationsState(res));
            console.log(res);
            const apiTabs = res.map(item => {
                const parsedMessage = JSON.parse(item.message);
                return {
                    title: `Sample responses for ${parsedMessage.type} ID ${parsedMessage.id} are ready for download.`, 
                    content: "The requests samples you required have been generated. Please click on the link below to download",
                    ID: item.id,
                    markStatus:  item.markStatus,
                    downloadLink: parsedMessage.downloadLink,
                };
            });
            setTabs(apiTabs); 
        } catch (error) {
            console.error('Error fetching notifications', error);
        }
    };


    const handleDownloadSample = (async(downloadLink)=>{
        try{
            const normalizedLink = downloadLink.startsWith('/api') ? downloadLink.replace('/api', '') : downloadLink;
            const reportingData = await getRequest(normalizedLink , null, navigate);
            const csvContent = reportingData; 
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const urlBlob = window.URL.createObjectURL(blob);
            link.setAttribute('href', urlBlob);
            link.setAttribute('download', `SupplySample.csv`);
            document.body.appendChild(link);
            link.click();
        }
        catch{
            console.log("error")
        }
    })

    const panelClassName = (parent, index) => {
        if (parent.state.activeIndex === index)
            return 'bg-primary'
    }

    const handleUpdateNotification = async (notificationID, status) => {
        try {
            const fetchedNotification = await getRequest(`/notifications/${notificationID}`, null, navigate);
            if (fetchedNotification) {
                const updatedNotification = { ...fetchedNotification, markStatus: status };
                setNotifications(updatedNotification); 
                await patchRequest(`/notifications/${notificationID}`, updatedNotification , navigate);
                fetchNotifications();   
            }
            else {
                console.log("Notification ID not found.");
            }
        } catch (error) {
            console.error(`Error updating notification status for ID ${notificationID}`, error);
        }
    };

    const handleDeleteNotification = async () => {
        if (deleteNotificationID) {
            try {
                await deleteRequest(`/notifications/${deleteNotificationID}`, null, navigate);
                if(toast.current){
                    toast.current.show({ severity: "success", summary: 'Success', detail: 'Notification has been successfully deleted'  });
                }
                fetchNotifications();
                setDeleteNotificationID(null);
            } catch (error) {
                if(toast.current){
                    toast.current.show({ severity: "error", summary: 'Error', detail: error });
                }
            }
        }
    }

    const headerDeleteNotification = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <span className="fs-1 white-space-nowrap">Delete notification</span>
        </div>
    );
    const footerDeleteNotification = (
        <div>
            <Button label="Cancel" className='button-style-2' onClick={() => setDeleteNotificationVisible(false)} autoFocus />
            <Button label="Delete" className='button-style-1' onClick={(e) => { handleDeleteNotification();setDeleteNotificationVisible(false) }} autoFocus
            />
        </div>
    );

    return (
        <div className='card'>
            <Toolbar className='main-content-header'>
                <Typography variant="h6" noWrap component="div">
                    <h2>Notifications</h2>
                </Typography>

                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    edge="start"
                    sx={{ mr: 2, display: { sm: 'none' } }}>
                    <MenuIcon />
                </IconButton>
            </Toolbar>

            <Box className='notifications-container'>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Box className='notifications-list-wrapper'>
                            <TabView>
                                {tabs.map((tab, i) => {

                                    const notificationList = (options) => {
                                        return (
                                            // <div className="align-items-center" onClick={options.onClick}>
                                            <div className="align-items-center" onClick={() => {
                                                options.onClick(); 
                                                handleUpdateNotification(tab.ID, false); 
                                            }}> 
                                                {/* <span className='title fs-1'>{tab.title}</span> */}
                                                <span className={tab.markStatus ? 'title fs-1 ' : 'sub-title fs-14-400' }>{tab.title}</span>
                                                {/* <span className='sub-title fs-14-400'>{tab.content}</span> */}
                                                <span className={tab.markStatus ? 'title fs-1' : 'sub-title fs-14-400' }>timeStamp</span>
                                            </div>
                                        );
                                    };
                                    return (
                                        <TabPanel
                                            pt={{
                                                headerAction: ({ parent }) => ({
                                                    className: panelClassName(parent, i)
                                                })
                                            }}
                                            key={i} headerTemplate={notificationList}>
                                            <Box className='notifications-content-body'>
                                                <div className='fs-20-600'>{tab.title}</div>
                                                <div className='fs-14-400'>{tab.content}</div>
                                                <a onClick={() => handleDownloadSample(tab.downloadLink)}  size="sm" className='download-link'> Download </a>
                                            </Box>
                                            <Box className='notifications-content-footer'>
                                                <a href='#' size="sm" className='download-link-normal' onClick={() => handleUpdateNotification(tab.ID, true)}> Mark as unread </a>
                                                <a href='#' size="sm" className='download-link-normal' onClick={() => {setDeleteNotificationID(tab.ID) ;setDeleteNotificationVisible(true)}}> Delete notification </a>
                                            </Box>
                                        </TabPanel>
                                    )
                                })}
                            </TabView>
                        </Box>
                    </Grid>
                </Grid>
            </Box>

            <Dialog className='sample-dialog' visible={visibleDeleteNotification} modal header={headerDeleteNotification} footer={footerDeleteNotification} style={{ width: '360px' }} onHide={() => setDeleteNotificationVisible(false)}>
                <p className="fs-12-500">
                    You have chosen to delete this notification. Once deleted, this notification will be removed from your notifications panel. Do you want to proceed?
                </p>
            </Dialog>
        </div>
    )
}
